import { gql } from "@apollo/client";

export const GET_PRODUCT_WITH_PAGINATION = gql`
  query pagination(
    $name: [String]
    $category: String
    $materialCategory: [String]
    $status: String
    $offset: Int!
    $limit: Int!
    $sort: String
    $companyId: String
    $imageTags: [String]
    $productCategories: [String]
    $recommendation: Boolean
    $withNoStyle: Boolean
    $isDemoProduct: Boolean
    $isAccessoriesProduct: Boolean
    $startDate: String
    $endDate: String
    $productStatus: String
  ) {
    getProductWithPagination(
      data: {
        name: $name
        category: $category
        materialCategory: $materialCategory
        status: $status
        offset: $offset
        limit: $limit
        sort: $sort
        companyId: $companyId
        imageTags: $imageTags
        productCategories: $productCategories
        recommendation: $recommendation
        withNoStyle: $withNoStyle
        isDemoProduct: $isDemoProduct
        isAccessoriesProduct: $isAccessoriesProduct
        startDate: $startDate
        endDate: $endDate
        productStatus: $productStatus
      }
    ) {
      _id
      total
      product {
        _id
        name
        objUrl
        fbxUrl
        gltfUrl
        usdzUrl
        styledGltfUrl
        status
        category
        description
        isExclusive
        uploadedDaeUrl
        selectedCompany
        detailView
        thumb
        companyId
        uniqueCode
        sku
        createdAt
        createdByUserName
        reviewedBy
        reviewedByUserName
        reviewedAt
        modifiedByUserName
        productStyleId
        modifiedAt
        emails {
          _id
          email
          message
          sentAt
          shortId
          active
          expirationDate
        }
        shareId
        tags
        companyName
        companyLogo
        cbm
        size
        supplierId
        partsMaterial {
          part
          material
        }
        sketchFabId
        noStyle
        specification {
          height
          width
          length
        }
        isDemoProduct
        isAccessoriesProduct
        price
        polyFoundryCategory
        customizedSettings
        accessoriesTags
        priceLabel
        priceValue
        envMap
        brightnessValue
        zoomLock
        selectedProductAttribute
        styleLights {
          _id
          name
          position {
            _id
            x
            y
            z
          }
          visible
          type
          intensity
          distance
          decay
          angle
          penumbra
        }
        polyFoundryVisible
        featuredProduct
        guestProduct
        storeCategories {
          _id
          title
          slug
          type
          icon
        }
        shareViewer
        threeDProductEditViewer
        storeSubCategories {
          _id
          parentCategoryId
          title
          slug
          type
          icon
        }
        storeMaterials {
          _id
          title
          slug
        }
        productStatus
        productListEditStatus
        productSegmentStatus
        productListNote
        productListNoteImg
        productListNoteImgThumb
        parts {
          _id
          partId: _id
          parts
          materialCategory
          materialCategoryName
          materialName
          name
          isCustomize
          materialId
          pantone
          hexCode
          colorType
          finishId
          finishName
          diffuse
          metallicRoughness
          finishThumb
          normal
          metalness
          ao
          aoValue
          roughness
          transparency
          patternId
          patternName
          patternDiffuse
          customiseFinishIds
          transparencyValue
          subFinishDiffuse
          isAlphaPattern
          alphaTest
          alphaDiffuse
          shapeId
          shapes {
            _id
            name
            objUrl
            gltfUrl
            fbxUrl
            thumb
            groupId
            __typename
          }
          limitedFinishes
          glossiness
          showInShare
          displacement
          displacementScale
          displacementBias
          repeatX
          repeatY
          offsetX
          offsetY
          rotate
          __typename
        }
        modelPosition {
          _id
          x
          y
          z
        }
        minPolarAngle
        maxPolarAngle
        foldersMeta {
          _id
          name
          folderId
        }
        modelScreenshotPosition {
          _id
          x
          y
          z
        }
        modelViewerSetting {
          exposure
          shadowIntensity
          legacyEnvironmentImage
          environmentImage
          cameraOrbit
          maxCameraOrbit
          minCameraOrbit
          disableZoom
          cameraTarget
          disableTap
          selectedToneMapping
          autoRotate
          transforms {
            roll
            pitch
            yaw
            scaleX
            scaleY
            scaleZ
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_WITH_PAGINATION_BY_ID = gql`
  query get($_id: String!, $companyId: String, $ref: String) {
    getProductStyleDetailById(_id: $_id, companyId: $companyId, ref: $ref) {
      _id
      name
      objUrl
      fbxUrl
      gltfUrl
      usdzUrl
      styledGltfUrl
      status
      uploadedDaeUrl
      category
      description
      isExclusive
      selectedCompany
      detailView
      thumb
      companyId
      uniqueCode
      sku
      createdAt
      createdByUserName
      reviewedBy
      reviewedByUserName
      reviewedAt
      modifiedByUserName
      productStyleId
      modifiedAt
      parts {
        _id
        partId: _id
        parts
        materialCategory
        materialCategoryName
        materialName
        name
        isCustomize
        materialId
        pantone
        hexCode
        colorType
        finishId
        finishName
        diffuse
        metallicRoughness
        finishThumb
        normal
        metalness
        ao
        aoValue
        roughness
        transparency
        patternId
        patternName
        patternDiffuse
        customiseFinishIds
        transparencyValue
        subFinishDiffuse
        isAlphaPattern
        alphaTest
        alphaDiffuse
        shapeId
        shapes {
          _id
          name
          objUrl
          gltfUrl
          fbxUrl
          thumb
          groupId
          __typename
        }
        limitedFinishes
        glossiness
        showInShare
        displacement
        displacementScale
        displacementBias
        repeatX
        repeatY
        offsetX
        offsetY
        rotate
        __typename
      }
      emails {
        _id
        email
        message
        sentAt
        shortId
        active
        expirationDate
        __typename
      }
      shareId
      FolderAttachment {
        file
        name
        type
        notes
        folderId
        createdAt
        __typename
      }
      tags
      companyName
      companyLogo
      cbm
      size
      supplierId
      renderedImages {
        _id
        thumb
        detailView
        renderId
        __typename
      }
      spin360Renders {
        _id
        thumb
        detailView
        renderId
        spin360
        __typename
      }
      partsMaterial {
        part
        material
        __typename
      }
      sketchFabId
      noStyle
      specification {
        height
        width
        length
        __typename
      }
      isDemoProduct
      isAccessoriesProduct
      price
      polyFoundryCategory
      customizedSettings
      accessoriesTags
      priceLabel
      priceValue
      envMap
      brightnessValue
      zoomLock
      selectedProductAttribute
      styleLights {
        _id
        name
        position {
          _id
          x
          y
          z
          __typename
        }
        visible
        type
        intensity
        distance
        decay
        angle
        penumbra
        __typename
      }
      polyFoundryVisible
      featuredProduct
      guestProduct
      storeCategories {
        _id
        title
        slug
        type
        icon
        __typename
      }
      shareViewer
      threeDProductEditViewer
      storeSubCategories {
        _id
        parentCategoryId
        title
        slug
        type
        icon
        __typename
      }
      storeMaterials {
        _id
        title
        slug
        __typename
      }
      productListEditStatus
      productSegmentStatus
      productListNote
      productListNoteImg
      productListNoteImgThumb
      modelPosition {
        _id
        x
        y
        z
        __typename
      }
      minPolarAngle
      maxPolarAngle
      foldersMeta {
        _id
        name
        folderId
        __typename
      }
      modelScreenshotPosition {
        _id
        x
        y
        z
        __typename
      }
      modelViewerSetting {
        exposure
        shadowIntensity
        legacyEnvironmentImage
        environmentImage
        cameraOrbit
        maxCameraOrbit
        minCameraOrbit
        disableZoom
        cameraTarget
        disableTap
        selectedToneMapping
        autoRotate
        transforms {
          roll
          pitch
          yaw
          scaleX
          scaleY
          scaleZ
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const GET_SKU_RELATED_PRODUCTS = gql`
  query getSKURelatedProducts($skuId: String! $companyId: String!) {
    getSKURelatedProducts(skuId: $skuId companyId: $companyId) {
      _id
      name
      price
      thumb
    }
  }
`;

export const GET_PRODUCT_COUNT_FOR_PAGINATION = gql`
  query paginationCount(
    $name: [String]
    $category: String
    $materialCategory: [String]
    $status: String
    $offset: Int!
    $limit: Int!
    $sort: String
    $companyId: String
    $imageTags: [String]
    $productCategories: [String]
    $recommendation: Boolean
    $withNoStyle: Boolean
    $isDemoProduct: Boolean
    $isAccessoriesProduct: Boolean
    $startDate: String
    $endDate: String
    $productStatus: String
  ) {
    getProductCountForPagination(
      data: {
        name: $name
        category: $category
        materialCategory: $materialCategory
        status: $status
        offset: $offset
        limit: $limit
        sort: $sort
        companyId: $companyId
        imageTags: $imageTags
        productCategories: $productCategories
        recommendation: $recommendation
        withNoStyle: $withNoStyle
        isDemoProduct: $isDemoProduct
        isAccessoriesProduct: $isAccessoriesProduct
        startDate: $startDate
        endDate: $endDate
        productStatus: $productStatus
      }
    ) {
      count
      message
    }
  }
`;
